import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBza3lsaW5lJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3ODg1NzI1Mnww&ixlib=rb-4.1.0&q=85";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      className="relative min-h-[100svh] flex items-end overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Skyline contemporanea"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/60 to-[#0A0A0A]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pb-20 lg:pb-28 pt-40 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="grid lg:grid-cols-12 gap-10 items-end"
        >
          <div className="lg:col-span-9">
            <div className="overline mb-6" data-testid="hero-overline">
              Studio Legale · Napoli · Milano
            </div>
            <div className="font-display text-[11px] tracking-[0.28em] uppercase text-[#FAF9F6]/60 mb-5">
              Studio Legale Ricciardi
            </div>
            <h1
              className="font-display text-[clamp(2.5rem,7vw,6rem)] leading-[0.95] tracking-tight font-bold"
              data-testid="hero-headline"
            >
              Corporate, Real Estate
              <span className="block text-[#C5A880] italic font-medium">
                &amp; Business Advisory.
              </span>
            </h1>
            <p
              className="mt-8 max-w-2xl text-lg lg:text-xl text-[#FAF9F6]/75 leading-relaxed"
              data-testid="hero-subtitle"
            >
              Assistenza legale a 360° a società, soci e investitori — dalla
              gestione operativa quotidiana alle operazioni più rilevanti.
              Un partner strategico integrato nel business, con la logica di
              un manager legale esterno.
            </p>
          </div>

          <div className="lg:col-span-3 lg:pl-8 lg:border-l border-[#FAF9F6]/10">
            <div className="overline mb-3">Approccio</div>
            <p className="text-sm text-[#FAF9F6]/70 leading-relaxed">
              Consulenza e assistenza legale operativa, attenzione al rischio
              e strutturazione efficace delle operazioni.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: "easeOut" }}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <button
            onClick={() => scrollTo("engage")}
            className="btn-primary inline-flex items-center justify-center gap-3 px-7 py-4 text-[12px] font-semibold tracking-[0.2em] uppercase"
            data-testid="hero-cta-prenota"
          >
            Prenota un confronto <ArrowUpRight size={16} strokeWidth={2.2} />
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-20 lg:mt-28 pt-8 border-t border-[#FAF9F6]/10 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10"
        >
          {[
            ["Diritto Commerciale", "Partner strategico per l'attività d'impresa"],
            ["Societario & M&A", "Governance e operazioni straordinarie"],
            ["Real Estate", "Diritto immobiliare & sviluppo"],
            ["Contenzioso", "Recupero crediti & assistenza giudiziale"],
          ].map(([k, v]) => (
            <div key={k}>
              <div className="font-display text-2xl lg:text-3xl font-medium">
                {k}
              </div>
              <div className="text-xs lg:text-sm text-[#FAF9F6]/60 mt-1">
                {v}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
